import * as React from 'react';
var SelectableContext = /*#__PURE__*/React.createContext(null);
export var makeEventKey = function makeEventKey(eventKey) {
  var href = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (eventKey != null) return String(eventKey);
  return href || null;
};
export default SelectableContext;